import React from 'react'
import Loadable from 'react-loadable'
import Table from 'UI/Table'
import JobsTable from './JobsTable'

const CopiesTable = ({ copies }) => (
  <Table
    filterable
    data={copies}
    pageSize={copies.length}
    showPagination={false}
    columns={[
      { Header: 'Name', accessor: 'name' },
      { Header: 'Data Written', accessor: 'data_written_in_bytes', Cell: row => row.original.data_written },
      { Header: 'Non-Aged Data Written', accessor: 'non_aged_data_written_in_bytes', Cell: row => row.original.non_aged_data_written },
      { Header: 'Job Count', accessor: 'job_count', Cell: ({ value }) => parseInt(value).toLocaleString() },
    ]}
    SubComponent={({ original: { jobs } }) => <JobsTable {...{ jobs }} />}
  />
)

export default CopiesTable
